/**
 * Function that animate a count up with an ease
 * @param {obj} element
 */
const countUpAnimation = (element) => {
    let frame = 0;
    const animationDuration = 1000;
    const frameDuration = 1000 / 60;
    const totalFrames = Math.round(animationDuration / frameDuration );
    const hasDecimals = element.classList.contains('countup--decimals');
    const countTo = hasDecimals ? parseFloat(element.getAttribute('data-countup')) : parseInt( element.getAttribute('data-countup'));
    const easeOutQuad = t => t * ( 2 - t );

    const counterInterval = setInterval( () => {
        frame++;
        const progress = easeOutQuad( frame / totalFrames );
        const currentCount = hasDecimals ? Intl.NumberFormat('nl-NL').format(Math.round( countTo * progress * 10) / 10) : Intl.NumberFormat('nl-NL').format(Math.round( countTo * progress ));

        element.innerText = currentCount;

        if( frame === totalFrames ) {
            clearInterval( counterInterval );
        }
    }, frameDuration);
}

window.countUpAnimation = countUpAnimation;
